import { useContext } from "react";

import appStyles from "../../../App.module.css";
import { formatDate } from "../../../app-constants";
import { AUBusinessTravelContext } from "../../AUBusinessTravel";
import btConstants from "../../config/bt-constants";
import { IAUBusinessTravelContext } from "../../config/interfaces";
import Footer from "../common/Footer";
import QuoteSummary from "../common/QuoteSummary";

const OrderDetail = () => {
  const { quoteData, isPaymentInvoice, order, version } = useContext(AUBusinessTravelContext) as IAUBusinessTravelContext;
  const orderDetail = {
    firstName: quoteData?.applicants[0]?.first_name,
    email: quoteData?.applicants[0]?.email,
  };
  return (
    <div className={`${appStyles.mainContainer} ${appStyles.btMainContainer}`}>
      <div className={`${appStyles.quoteResultWrapper} ${appStyles.btQuoteResultWrap}`}>
        <div className={`${appStyles.quoteDetailsBox}`}>
          <h1 className={`${appStyles.btConfirmationTitle}`}>
            {isPaymentInvoice ? "Your order is pending" : "Congratulations! You’re covered"}
          </h1>

          <div className={` ${appStyles.quoteFormOtherTravelerInformation}`}>
            <div className={appStyles.formRow}>
              {isPaymentInvoice ? (
                <div>
                  <p className={appStyles.btPaymentMessage}>
                    Thanks&nbsp;
                    <span className={appStyles.btTextBold}>{orderDetail.firstName}</span>! We will send an invoice to
                    <span className={appStyles.btTextBold}>&nbsp;{orderDetail.email}&nbsp;</span>
                    within 2 working days. Please arrange payment within 5 working days of receipt.&nbsp;
                  </p>
                  <p className={appStyles.btPaymentMessage}>
                    If you do not receive your invoice please contact us at&nbsp;
                    <span className={appStyles.btTextBold}>
                      {version === "UK" ? btConstants.UKTelephone : btConstants.EUTelephone}
                      &nbsp;
                    </span>
                    or by email at&nbsp;
                    <span className={appStyles.btTextBold}>
                      {version === "UK" ? btConstants.UKEmail : btConstants.EUEmail}
                    </span>
                    .
                  </p>
                  <p className={appStyles.btPaymentMessage}>
                    If payment is not received within 5 working days of the invoice being sent, your order will be
                    cancelled and you will have to create a new quote; prices may differ.
                  </p>
                </div>
              ) : (
                <p className={appStyles.btPaymentMessage}>
                  Thanks&nbsp;
                  <span className={appStyles.btTextBold}>{orderDetail.firstName}</span>! Both your Policy and
                  Certificate of Insurance have been emailed to
                  <span className={appStyles.btTextBold}>&nbsp;{orderDetail.email}</span>
                </p>
              )}
            </div>
            <div className={appStyles.btPaymentDetailWrapper}>
              <h2 className={appStyles.btPaymentDetailWrap}>
                <span className={appStyles.btPaymentLabel}>Order number:</span>
                &nbsp;
                {order?.order_number || 0}
              </h2>
              {!isPaymentInvoice && (
                <h2 className={appStyles.btPaymentDetailWrap}>
                  <span className={appStyles.btPaymentLabel}>Policy number:</span>
                  &nbsp;
                  {order?.items[0]?.policy_number}
                </h2>
              )}
              <h2 className={appStyles.btPaymentDetailWrap}>
                <span className={appStyles.btPaymentLabel}>Order date:</span>
                &nbsp;
                {formatDate(new Date(order?.ordered_at))}
              </h2>
            </div>
          </div>
        </div>

        <QuoteSummary showPolicyTerm={true} />
      </div>
      <Footer />
    </div>
  );
};

export default OrderDetail;
